import { Badge, Col, Row, Tag, Typography } from 'antd';
import { GetUserResponse } from 'App/api/endpoints/users/responses';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface UserGeneralTabProps {
	user: GetUserResponse;
}

const UserGeneralTab = ({ user }: UserGeneralTabProps) => {
	const { t } = useTranslation(['page', 'form', 'common']);

	if (user) {
		return (
			<>
				<Row gutter={[16, 16]}>
					<Col span={24}>
						<Typography>
							<Typography.Text type='secondary'>
								{t('models:User.Labels.FirstName')}:{' '}
							</Typography.Text>
							<Typography.Text>{user.firstName}</Typography.Text>
						</Typography>
					</Col>
					<Col span={24}>
						<Typography>
							<Typography.Text type='secondary'>
								{t('models:User.Labels.LastName')}:{' '}
							</Typography.Text>
							<Typography.Text>{user.lastName}</Typography.Text>
						</Typography>
					</Col>
					<Col span={24}>
						<Badge
							status={user.emailConfirmed ? 'success' : 'default'}
							title={
								user.emailConfirmed
									? t('AdminPages.UsersPages.StatusConfirmed')
									: t('AdminPages.UsersPages.StatusUnConfirmed')
							}
						>
							<Typography>
								<Typography.Text type='secondary'>
									{t('models:User.Labels.Email')}:{' '}
								</Typography.Text>
								<Typography.Text>{user.email}</Typography.Text>
							</Typography>
						</Badge>
					</Col>
					<Col span={24}>
						<Badge
							status={user.phoneNumberConfirmed ? 'success' : 'default'}
							title={
								user.phoneNumberConfirmed
									? t('AdminPages.UsersPages.StatusConfirmed')
									: t('AdminPages.UsersPages.StatusUnConfirmed')
							}
						>
							<Typography>
								<Typography.Text type='secondary'>
									{t('models:User.Labels.PhoneNumber')}:{' '}
								</Typography.Text>
								<Typography.Text>
									{user.phoneNumber || t('AdminPages.UsersPages.BlankPhoneNumber')}
								</Typography.Text>
							</Typography>
						</Badge>
					</Col>
					<Col span={24}>
						<Typography>
							<Typography.Text type='secondary'>
								{t('models:User.Labels.UserName')}:{' '}
							</Typography.Text>
							<Typography.Text>{user.userName}</Typography.Text>
						</Typography>
					</Col>
					<Col span={24}>
						<Typography>
							<Typography.Text type='secondary'>{t('models:User.Labels.Roles')}: </Typography.Text>
							{user.roles.map((role, index) => {
								const generatedRoleKey = `common:Roles.${role}`;
								return <Tag key={index}>{t(generatedRoleKey)}</Tag>;
							})}
						</Typography>
					</Col>
				</Row>
			</>
		);
	} else {
		return <></>;
	}
};

export default UserGeneralTab;
